import { Icon, type IconProps } from "@chakra-ui/react";
import React from "react";

export function LeversIcon(props: IconProps) {
  return (
    <Icon width="20px" height="20px" viewBox="0 0 20 20" fill="none" {...props}>
      <path
        d="M15.333 16v-3.333M13.333 12.667h4M4.667 16v-4.667M2.667 11.333h4M10 16v-6M8 7.333h4M15.333 10V4M10 7.333V4M4.667 8.667V4"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Icon>
  );
}
